import { Text, View } from '@react-pdf/renderer';
import { StringKeys } from '../../resources/strings/StringKeys';
import { StyleSheet } from '@react-pdf/renderer';
export const reportStyles = StyleSheet.create({
  generatedBySection: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    textAlign: 'right',
  },
  footerText: {
    fontSize: 8,
  },
});

export const FooterText = ({ user, t }) => (
  <View style={reportStyles.generatedBySection}>
    <Text style={reportStyles.footerText}>
      {t(StringKeys.CREATED_BY)}: {user.first_name} {user.last_name}{' '}
      {t(StringKeys.DATE)}: {new Date().toLocaleDateString()}
    </Text>
  </View>
);
